export type BombConfig = {
  chargeMax: number
  comboStep: number
  comboPerfectBonus: number
  killCharge: number
  overdriveBonus: number
  damagePenalty: number
  comboDropPenalty: number
  activationWindowMs: number
  perfectWindowMs: number
  missPenalty: number
}

export const bombConfig: BombConfig = {
  chargeMax: 100,
  comboStep: 9,
  comboPerfectBonus: 4,
  killCharge: 4,
  overdriveBonus: 6,
  damagePenalty: 18,
  comboDropPenalty: 10,
  activationWindowMs: 140,
  perfectWindowMs: 60,
  missPenalty: 22
}
